<template lang="pug">
.ride-card-item-container()
  .ride-card-left(@click="openBuyModal")
    .ride-card-left-title {{packageData.showName}}
    .ride-card-left-cheaper(v-if="diffMoney(packageData)>0")
      span 已优惠
      span.red-word {{diffMoney(packageData)}}
      span 元
    .ride-card-left-subtitle {{getTags(packageData)}}
  .ride-card-right
    .ride-card-price
      .ride-card-big {{getNumber(packageData.actualPrice.finalPrice)}}
      .ride-card-small 元
    .ride-card-middle() {{getNumber(packageData.originPrice)}}元
    .ride-card-btn(@click="buyCard(packageData)") 购买
</template>
<script>
import eventBus from '@/const/eventBus.js';
import { CardService } from '@/service/card';
import Toast from '@/components/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import {
  getNoScroll,
} from '@/utils';
import { debounce } from '@/utils/index';

export default {
  props: {
    packageData: {
      type: Object,
      default() {
        return {
          showName: '',
          purchasePrice: '',
          originPrice: '',
          actualPrice: {
            finalPrice: '',
          },
        };
      },
    },
  },
  inject: ['getAgreementInfo', 'latestTabCode'],
  methods: {
    getNumber(val) {
      if (val && (typeof val === 'string')) {
        return parseFloat(val);
      }
      return val;
    },

    openBuyModal() {
      this.$emit('buyCard', this.packageData);
    },

    buyCard: debounce(function buyCardClick() {
      // 如果命中合规，需要展示协议，则需要弹出购买浮层，若未命中，则直接调起收营台
      const { gray } = this.getAgreementInfo();
      if (gray) {
        this.openBuyModal();
        return;
      }
      const tabCode = this.latestTabCode();
      this.params = {
        businessType: (tabCode === 'bike' ? 1 : 2),
        channelCode: this.packageData.channelCode,
        adSource: (tabCode === 'bike' ? 'VIPbikecard' : 'VIPebikecard'),
      };
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_sale_card',
        categoryId: 'platform',
        businessInfo: {
          virtualId: this.packageData.packageGuid,
          cardname: this.packageData.showName,
          businessType: tabCode === 'bike' ? '1' : '2',
        },
      });
      // 直接调接口
      CardService.buy(this.packageData, this.params || {}).then(() => {
        Toast.show('支付成功');
        getNoScroll(false);
        eventBus.$emit('refreshNewMember');
      });
    }, 300),
    diffMoney(packageData) {
      if (packageData && packageData.actualPrice && packageData.originPrice) {
        return this.getNumber((packageData.originPrice - packageData.actualPrice.finalPrice).toFixed(2));
      }
      return '';
    },
    getTags(packageData) {
      if (packageData && packageData.marketingWords) {
        return packageData.marketingWords
          .filter((item) => item.wordsValue !== 1) // 先过滤
          .map((item) => item.wordsValue) // 再提取目标字段
          .join('｜ ');
      }
      return '';
    },
  },
};
</script>
<style lang="less" scoped>
.ride-card-item-container {
  height: 0.93rem;
  border-radius: 0.16rem;
  background: #fff;
  margin-bottom: 0.08rem;
  display: flex;
  justify-content: space-between;
  padding: 0.15rem;
  margin-bottom: 0.08rem;

  .ride-card-left {
    .ride-card-left-title {
      font-family: PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 500;
      line-height: 0.224rem;
      color: #242729;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 2.5rem;
    }

    .ride-card-left-cheaper {
      margin-top: 0.04rem;
      border: 0.01rem solid #e0e7ed;
      background: #fbfdff;
      color: #879099;
      font-family: PingFang SC, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      border-radius: 0.05rem;
      height: 0.16rem;
      text-align: center;
      line-height: 0.16rem;
      display: inline-block;
      padding: 0 0.04rem;

      span.red-word {
        color: #ff5626;
      }
    }

    .ride-card-left-subtitle {
      margin-top: 0.04rem;
      font-family: PingFang SC, sans-serif;
      font-size: 0.12rem;
      font-weight: 400;
      line-height: 0.168rem;
      color: #879099;
    }
  }

  .ride-card-right {
    .ride-card-price {
      display: flex;
      color: #08f;
      justify-content: flex-end;

      .ride-card-big {
        font-family: "DIN Alternate Bold", sans-serif;
        font-size: 0.2rem;
        font-weight: 700;
        line-height: 0.2442rem;
      }

      .ride-card-small {
        margin-left: 0.02rem;
        font-family: PingFang SC, sans-serif;
        font-size: 0.11rem;
        font-weight: 400;
        line-height: 0.154rem;
        margin-top: 0.08rem;
      }
    }

    .ride-card-middle {
      font-family: PingFang SC, sans-serif;
      font-size: 0.11rem;
      font-weight: 400;
      line-height: 0.154rem;
      color: #879099;
      text-decoration-line: line-through;
      text-align: right;
    }

    .ride-card-btn {
      margin-top: 0.05rem;
      width: 0.5rem;
      height: 0.22rem;
      text-align: center;
      line-height: 0.22rem;
      background: #08f;
      color: #fff;
      border-radius: 0.5rem;
      font-weight: 500;
      font-size: 0.12rem;
    }
  }
}
</style>
